import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";
import store from "../store";

const AdminTrainingInfoStore = {
  namespaced: true,
  debug: true,
  state: {
    memberList: [],
    memberDetail: {},
    reservedMemberList: [],
    contractInfo: []
  },
  mutations: {
    setMemberList(state, data) {
      state.memberList = data;
    },
    setMemberDetail(state, data) {
      state.memberDetail = data;
    },
    setReservedMemberList(state, data) {
      state.reservedMemberList = data;
      state.reservedMember = data;
    },
    setContractInfo(state, data) {
      state.contractInfo = data;
    }
  },
  getters: {
    getMemberList(state) {
      if (state.memberList.errorCode === "FirebaseError") {
        let result = [];
        return result;
      }
      return state.memberList.map(val => {
        let result = {
          name: val.lastname + val.firstname,
          phone: val.phone,
          cardId: val.cardid,
          sex: val.sex,
          status: val.status,
          uid: val.uid,
          lastMonthStatus: val.lastmonthstatus,
          automaticUpdatingDate: val.automaticupdatingdate
        };
        if (result.sex != null && result.sex != "") {
          result.sex = store.getters[
            "constantStore/constant/constantStore/getSexData"
          ](result.sex).label;
        }
        if (result.status != null && result.status != "") {
          if (
            result.automaticUpdatingDate != null &&
            result.automaticUpUatingDate != "" &&
            result.automaticUpdatingDate > moment().format("YYYY-MM-DD")
          ) {
            //自動更新日時が存在して、且つ現在時刻よりも先の日時である場合のみ先月ステータスを使う
            result.statusLabel = store.getters[
              "constantStore/constant/constantStore/getMemberStatusData"
            ](result.lastMonthStatus).label;
          } else {
            result.statusLabel = store.getters[
              "constantStore/constant/constantStore/getMemberStatusData"
            ](result.status).label;
          }
        }
        return result;
      });
    },
    getMemberDetail(state) {
      let result = {
        cardId: state.memberDetail.cardid,
        lastName: state.memberDetail.lastname,
        firstName: state.memberDetail.firstname,
        lastNameKana: state.memberDetail.lastnamekana,
        firstNameKana: state.memberDetail.firstnamekana,
        phone: state.memberDetail.phone,
        birthday:
          state.memberDetail.birthday != null
            ? moment(state.memberDetail.birthday).format("YYYY-MM-DD")
            : "",
        sex: state.memberDetail.sex,
        zipCode: state.memberDetail.zipcode,
        prefectures: state.memberDetail.prefectures,
        city: state.memberDetail.city,
        address: state.memberDetail.address,
        building: state.memberDetail.building,
        joinDate:
          state.memberDetail.joindate != null
            ? moment(state.memberDetail.joindate).format("YYYY-MM-DD")
            : ""
      };
      if (result.sex != null) {
        result.sex = store.getters[
          "constantStore/constant/constantStore/getSexData"
        ](result.sex);
      }
      if (result.prefectures != null) {
        result.prefectures = store.getters[
          "constantStore/constant/constantStore/getPrefecturesData"
        ](result.prefectures);
      }
      return result;
    },
    getReservedMemberList(state) {
      return state.reservedMemberList.map(val => {
        let result = {
          uid: val.uid,
          displayName: val.lastname + " " + val.firstname + " 様",
          reservationNumber: val.reservationnumber,
          scheduleNumber: val.schedulenumber,
          isJoin: val.isjoin,
          displayDetail: " " + val.detail,
          birthday: moment(val.birthday).format("YYYY-MM-DD")
        };
        return result;
      });
    },
    getContractInfo(state) {
      let result = {
        reservationAvailableCount: state.contractInfo.reservationavailablecount,
        startDate:
          state.contractInfo.startdate != null
            ? moment(state.contractInfo.startdate).format("YYYY-MM-DD")
            : "",
        endDate:
          state.contractInfo.enddate != null
            ? moment(state.contractInfo.enddate).format("YYYY-MM-DD")
            : "",
        status: state.contractInfo.status,
        maxReservationCount: state.contractInfo.maxreservationcount,
        lastMonthReservationAvailableCount:
          state.contractInfo.lastmonthreservationavailablecount,
        lastMonthStatus: state.contractInfo.lastmonthstatus,
        lastMonthMaxReservationCount:
          state.contractInfo.lastmonthmaxreservationcount
      };
      if (state.contractInfo.automaticupdatingdate != null) {
        result.modifyFlag = true;
        result.automaticUpdatingDate = moment(
          state.contractInfo.automaticupdatingdate
        ).format("YYYY-MM");
        result.reservationLabel =
          moment(state.contractInfo.automaticupdatingdate).format("YYYY/MM") +
          "予約可能数";
        result.lastMonthReservationLabel =
          moment(state.contractInfo.automaticupdatingdate)
            .add(-1, "months")
            .format("YYYY/MM") + "予約可能数";
        result.statusLabel =
          moment(state.contractInfo.automaticupdatingdate).format("YYYY/MM") +
          "ステータス";
        result.lastMonthStatusLabel =
          moment(state.contractInfo.automaticupdatingdate)
            .add(-1, "months")
            .format("YYYY/MM") + "ステータス";
        result.maxReservationLabel =
          moment(state.contractInfo.automaticupdatingdate).format("YYYY/MM") +
          "契約コース(回数)";
        result.lastMonthMaxReservationLabel =
          moment(state.contractInfo.automaticupdatingdate)
            .add(-1, "months")
            .format("YYYY/MM") + "契約コース(回数)";
      } else {
        result.automaticUpdatingDate = "";
        result.lastMonthReservationLabel = "未使用項目";
        result.reservationLabel = "予約可能数";
        result.statusLabel = "ステータス";
        result.lastMonthStatusLabel = "未使用項目";
        result.maxReservationLabel = "契約コース(回数)";
        result.lastMonthMaxReservationLabel = "未使用項目";
        result.modifyFlag = false;
      }
      if (result.status != null) {
        result.status = store.getters[
          "constantStore/constant/constantStore/getMemberStatusData"
        ](result.status);
      }
      if (result.lastMonthStatus != null) {
        result.lastMonthStatus = store.getters[
          "constantStore/constant/constantStore/getMemberStatusData"
        ](result.lastMonthStatus);
      }
      return result;
    }
  },
  actions: {
    async callApiMemberList({ commit }, searchInfo) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let memberList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/memberList",
            {
              searchName: searchInfo.searchName,
              searchPhone: searchInfo.searchPhone
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setMemberList", memberList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiMemberDetail({ commit }, uid) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let memberDetail = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/userInfo",
            {
              uid: uid
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setMemberDetail", memberDetail.data[0]);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiReservedMemberList({ commit }, schedulenumber) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let reservedMemberList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/reservedMemberList",
            {
              scheduleNumber: schedulenumber
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setReservedMemberList", reservedMemberList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiContractInfo({ commit }, uid) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let contractInfo = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/contractInfo",
            {
              uid: uid
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setContractInfo", contractInfo.data[0]);
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default AdminTrainingInfoStore;
